<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M3 4C3 2.89543 3.89543 2 5 2V4H3Z" fill="currentColor" />
  <path d="M17 4C17 2.89543 16.1046 2 15 2V4H17Z" fill="currentColor" />
  <path
    d="M8 4H12V5C13.1046 5 14 5.89543 14 7V12H15C15.5523 12 16 12.4477 16 13V14H4V12C4 11.4477 4.44772 11 5 11H6V7C6 5.89543 6.89543 5 8 5V4Z"
    fill="currentColor"
  />
  <path
    d="M8 15H12V16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16V15Z"
    fill="currentColor"
  />
</svg>
